import React, {Component} from 'react'
import * as routes from '../../const/routes'
import Video from '../../components/Video'
import VideoPage from '../../components/VideoPage'
import CloseBtn from '../../components/CloseBtn'
import * as videos from '../../const/videos'
import {withUiContext} from "../../UiContext";
import Languages from '../../const/languages'

const video = videos.kooperCenter

class KooperCenter extends Component {

    onEnded = () => {
        const { ui } = this.props

        ui.setDriverStatus(false)
        this.props.history.push(routes.KOOPER)
    }

    render() {
        return (
            <VideoPage title={Languages.dataCenter}>
                <Video video={video} closeLink={routes.KOOPER} onEnded={this.onEnded}/>
                <CloseBtn link={routes.KOOPER}/>
            </VideoPage>
        )
    }
}

export default withUiContext(KooperCenter)
